module.exports = __webpack_public_path__ + "static/media/deliveryman.e2b61c48.png";